import React, { useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import { apiClient } from 'pobble-components/dist/api'
import { Image } from 'pobble-components/dist/image'
import Button from 'pobble-components/dist/button'
import Spinner from 'pobble-components/dist/spinner'
import { useHistory } from 'react-router-dom'
import {
  PARENT_CARD,
  PARENT_PAGE_BG,
  PARENT_PAGE_HEADER,
  PARENT_PRIMARY_CTA
} from './parent-theme'

const DEFAULT_INCLUDE =
  'presentation.audio,presentation.p365,presentation.account,presentation.category,presentation.status,presentation.image,presentation.year_groups,presentation.details,presentation.slides,presentation.slide.type,presentation.slide.details,presentation.names'

const CARD_ORDER = ['Yesterday', 'Today', 'Tomorrow']

export const ParentLessonSelector = injectSheet({
  container: {
    minHeight: 'calc(100vh - 80px)',
    background: PARENT_PAGE_BG,
    color: 'var(--gray)',
    padding: '48px 20px 56px',
    '@media (min-width: 1024px)': {
      padding: '72px 56px 88px'
    }
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  header: PARENT_PAGE_HEADER,
  cardsGrid: {
    display: 'grid',
    gap: '24px',
    gridTemplateColumns: '1fr',
    '@media (min-width: 768px)': {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))'
    }
  },
  card: PARENT_CARD,
  imageHolder: {
    background: 'var(--purple--)',
    aspectRatio: '16 / 9'
  },
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  cardBody: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  cardLabel: {
    margin: '0 0 8px',
    font: 'var(--body-)',
    color: 'var(--purple)',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.04em'
  },
  cardTitle: {
    margin: '0 0 10px',
    font: 'var(--heading-)',
    color: 'var(--gray)',
    minHeight: '32px'
  },
  cardDescription: {
    margin: '0 0 18px',
    color: 'var(--gray--)',
    font: 'var(--body)',
    lineHeight: 1.5,
    minHeight: '44px'
  },
  cardCta: PARENT_PRIMARY_CTA,
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '32px 0'
  }
})(({ classes }) => {
  const history = useHistory()
  const [adjacentPresentations, setAdjacentPresentations] = useState([])

  useEffect(() => {
    let mounted = true

    apiClient
      .get('/v3/p365/today', {
        params: {
          count: 1,
          from: 0,
          include: DEFAULT_INCLUDE
        }
      })
      .then(res => {
        const today = res.data.presentations && res.data.presentations[0]
        if (!today || !mounted) return null

        return apiClient.get(`/v3/p365/${today.id}`, {
          params: {
            count: 3,
            from: 0,
            include:
              'presentation.image,presentation.names,presentation.details,presentation.slides,presentation.slide.type,presentation.slide.details'
          }
        })
      })
      .then(res => {
        if (!res || !mounted) return
        setAdjacentPresentations((res.data.presentations || []).slice(0, 3))
      })
      .catch(() => {
        if (mounted) setAdjacentPresentations([])
      })

    return () => {
      mounted = false
    }
  }, [])

  return (
    <section className={classes.container}>
      <div className={classes.inner}>
        <header className={classes.header}>
          <h2>Ready to write together?</h2>
          <p>
            Pick a picture prompt, talk about it together, <br /> and see where
            the writing takes you.
          </p>
        </header>

        {adjacentPresentations.length === 3 ? (
          <div className={classes.cardsGrid}>
            {adjacentPresentations.map((presentation, index) => (
              <article key={presentation.id} className={classes.card}>
                <div className={classes.imageHolder}>
                  <Image
                    className={classes.cardImage}
                    src={presentation.image && presentation.image.url}
                    alt={presentation.title}
                  />
                </div>
                <div className={classes.cardBody}>
                  <p className={classes.cardLabel}>{CARD_ORDER[index]}</p>
                  <h3 className={classes.cardTitle}>{presentation.title}</h3>
                  {!!presentation.slides &&
                    !!presentation.slides[3] &&
                    !!presentation.slides[3].text && (
                      <p className={classes.cardDescription}>
                        {presentation.slides[3].text.slice(0, 200)}...
                      </p>
                    )}
                  <Button
                    className={classes.cardCta}
                    action={() =>
                      history.push(`/parent/lesson/${presentation.id}`)
                    }
                    tall>
                    Start here
                  </Button>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className={classes.loading}>
            <Spinner />
          </div>
        )}
      </div>
    </section>
  )
})
